import styled from 'styled-components';

import { size } from '../../StyledComponents/layout/helpers';
import { Link } from '../Link';

const iconSize = '1.2rem';
const titleSize = '1rem';
const titleLineHeight = '1.5';

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: ${size(-1)};
`;

export const Item = styled.li`
  flex: 1 0 auto;
  width: 100%;
  max-width: 100%;
  padding: ${size(1)};

  ${({ theme }) => theme.breakpoint.Sm} {
    width: 50%;
    max-width: 50%;
  }
`;

export const Tile = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: ${size(2)};
  border: 1px solid ${(props) => props.theme.color.border};
  border-radius: 3px;

  &:hover {
    background-color: ${(props) => props.theme.color.hoverOverlay};
  }
`;

export const Info = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: flex-start;
  min-width: 0;
`;

export const Icon = styled.div`
  flex-shrink: 0;
  padding-right: ${size(1.5)};
  font-size: ${iconSize};
  margin-top: calc((${iconSize} - ${titleSize} * ${titleLineHeight}) / -2);
`;

export const Name = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const Title = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${titleSize};
  line-height: ${titleLineHeight};
`;

export const Subtitle = styled.div`
  color: ${(props) => props.theme.color.textDarkLighten};
  font-size: 0.875rem;
`;

export const Action = styled.div`
  flex-shrink: 0;
  padding-left: ${size(2)};
  font-size: 0.875rem;

  ${Link} {
    &:hover {
      text-decoration: none;
    }
  }
`;
